import { motion } from "framer-motion";
import { DISCORD_URL } from "../../lib/site";
import { useI18n } from "../../i18n/LanguageContext";
import { DiscordIcon } from "./DiscordIcon";

export const FinalCTA = () => {
  const { t } = useI18n();
  return (
    <section className="relative pb-24 md:pb-32 px-5 md:px-8" data-testid="final-cta">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative max-w-6xl mx-auto overflow-hidden rounded-[2rem] bg-brand px-6 py-20 md:py-28 text-center"
      >
        <div className="absolute inset-0 noise opacity-[0.10] mix-blend-overlay pointer-events-none" />
        <div className="absolute -top-24 -right-16 h-64 w-64 rounded-full bg-white/20 blur-3xl" />
        <div className="relative">
          <span className="mx-auto mb-7 grid h-16 w-16 place-items-center rounded-2xl bg-[#080a0f]/10 text-[#08131f]">
            <DiscordIcon className="h-8 w-8" />
          </span>
          <h2 className="font-display font-black text-4xl md:text-6xl tracking-tighter text-[#06131f]">
            {t.cta.title}
          </h2>
          <p className="mt-5 mx-auto max-w-md text-[#0a1a26]/80 text-base md:text-lg">
            {t.cta.subtitle}
          </p>
          <a
            data-testid="final-join-discord"
            href={DISCORD_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-9 inline-flex items-center gap-2.5 rounded-full bg-[#080a0f] text-white font-semibold px-7 py-4 hover:bg-[#0d1119] transition-colors duration-300 active:scale-[0.98]"
          >
            <DiscordIcon className="h-5 w-5 text-cyan-400" />
            {t.cta.join}
          </a>
        </div>
      </motion.div>
    </section>
  );
};
